var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Menu extends Component {
    constructor() {
        super('Menu', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.button-toggle-menu').on('click', (event, button) => {
                event.preventDefault();
                button.toggleClass('active');
                $('.header-baseline').toggleClass('invisible');
                $('#main-menu').toggleClass('opened');
            });
            $(window).on('resize', () => {
                this.setMaxHeight();
            });
            $('#main-menu .menu-item > a').on('click', (event, item) => {
                if ($(window).width() >= 768 || item.next().length === 0)
                    return;
                event.preventDefault();
                item.toggleClass('is-active');
                item.next().toggleClass('is-opened');
            });
            this.setMaxHeight();
            this.success();
        });
    }
    setMaxHeight() {
        $('#main-menu').css('--max-height', $('#main-menu .container').height() + 'px');
    }
}
